import type { CSSProperties } from 'react';
import { adTypeToPlatform, CHANNEL_PLATFORM_META } from '@/lib/utils/channelPlatformMeta';

/**
 * Returns inline badge style for a partnership/advertising type chip.
 * Maps the type ID to its platform (YouTube, Twitch, etc.) and uses the
 * platform's brand color/backgroundColor from CHANNEL_PLATFORM_META.
 */
export function getPartnershipBadgeStyle(
  typeId: string,
): CSSProperties | undefined {
  if (!typeId) return undefined;
  const platform = adTypeToPlatform(typeId);
  if (!platform) return undefined;
  const meta = CHANNEL_PLATFORM_META[platform];
  if (!meta) return undefined;
  return {
    backgroundColor: meta.backgroundColor,
    color: meta.color,
    borderColor: meta.backgroundColor,
  };
}
